import { Koi } from '@ksyos/koi';
import type { Medication } from '../medication';
import { medications } from '../medication';

export type ProcessActivityMedicationData = {
    medications: Medication[];
    patientUsesMedication: boolean | null;
};

export const processActivityMedicationDataSchema = Koi.object({
    medications: medications,
    patientUsesMedication: Koi.boolean(),
});

export const processActivityMedicationDraftDataSchema = Koi.object({
    medications: medications,
    patientUsesMedication: Koi.boolean().allow(null),
});

export const processActivityInitialMedicationData: ProcessActivityMedicationData = {
    medications: [],
    patientUsesMedication: null,
};
